import { useIonViewDidEnter, IonChip, IonBackdrop, IonGrid, IonCol, IonRow, IonList, IonInfiniteScroll, IonInfiniteScrollContent, IonAvatar, IonIcon, IonBadge, IonImg, IonRefresherContent, IonRefresher, useIonRouter, useIonViewWillEnter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState, useContext } from "react";
import { notificationsOutline, heart, notificationsCircleOutline } from 'ionicons/icons';
import { Plugins, Capacitor } from '@capacitor/core';
import { Virtuoso } from 'react-virtuoso';
import { AdOptions, AdSize, AdPosition } from "capacitor-admob";

import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';

import { showTab, updateTab } from "../components/Tabs";
import { showAlert } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { Device } from '@capacitor/device';
import { Browser } from '@capacitor/browser';
import NServer, { UIElement, handleRouteError, RegisterAppServices } from "../components/NServer";
import { ContentInfo, CreateContentInfo, FilterUniqueContent, ReponsiveContentResize, ReponsiveContentItemResize } from "../data/item";
import ContentWrapper from "../components/ContentWrapper";
import { AdsInfo, InitAdMobs, ReadyAds, ShowAds, WriteAdInfo } from "../components/Admob";
import NoMoreContent from "../components/NoMoreContent";
import NotiContext from "../components/NotiContext";

import './Main.css'; 

var index = 0;
const total = 4;
var noMoreLoadData = false;
var loading = false;
var user_avatar = "/assets/img/avt.jpg";

const Main : React.FC = () => {

    const [noti, setNoti] = useState(2);
    const [contents, setContents] = useState<ContentInfo[]>([]);
    const [streams, setStreams] = useState<ContentInfo[]>([]);
    const [canRefresh, setCanRefresh] = useState(true);
    const [endOfContent, setEndOfContent] = useState(false);
    const [userAvatar, setUserAvatar] = useState("/assets/img/avt.jpg");
    const [tokens, setTokens] = useState(0);
    const [alert, setAlert] = useState("");

    //	Initializing our router
	const router = useIonRouter();

    useIonViewDidEnter(() => {
        // check window scroll position
        var doc = document.getElementById("main-con-view");
        var top = 0;
        if (doc != null)
            top = doc.scrollTop;

        // refresh
        if (index == 0 || top < 1)
            doRefresh(null);

        // load again in case first time is not loaded
        setTimeout( () => {
            let e = document.getElementById('nc-content');
            if (e == null && !loading)
                doRefresh(null);
        }, 1000);

        showTab();

        RegisterAppServices();
    });

    // scroll event
    const onScrollTop = (val : boolean) => {
        setCanRefresh(val);
    }

    const loadMoreData = async () => {
        if (noMoreLoadData || loading)
            return;

        await getData();
    }

    const getData = async () => {

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            s: index,
            e: total
        }

        loading = true;

        var server = new NServer();
        await server.getList("nc_main", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);

            handleRouteError(router, server.data);
        }
        else
        {
            const d = server.data;

            if (d != null)
            {
                if (d.hasOwnProperty('path'))
                {
                    if (d.path == "license")
                        router.push("/license", "back", "pop");
                    else if (d.path == "lock")
                        router.push("/lockscr", "back", "pop");
                }

                if (d.hasOwnProperty("admob"))
                {
                    let adInfo : AdsInfo = d.admob;
                    WriteAdInfo(adInfo);
                }

                setTokens(server.data.token);
                setUserAvatar(server.data.avatar);

                user_avatar = server.data.avatar;

                var dataStream = null;
                if (server.data.stream != null)
                {
                    if (index == 0)
                        dataStream = server.data.stream;
                    else
                        dataStream = streams.concat(server.data.stream);
                    
                    // filter
                    dataStream = FilterUniqueContent(dataStream);
                    // responsive resize
                    dataStream = ReponsiveContentResize("main-con-view", dataStream);
		            
                    setStreams(dataStream);
                }
                
                // if we reach end of data
                noMoreLoadData = server.data.nomore == "yes";
                index = server.data.index;

                let contentStream = getDefContents().concat(dataStream);
                
                setContents(contentStream);

                setAlert(server.data.alert);

                setEndOfContent(noMoreLoadData);
            }
        }

        loading = false;

        updateTab();
    }

    // refresh event
    const doRefresh = async (ev : any) => {
        index = 0;
        noMoreLoadData = false;
        loading = false;

        await getData();

        if (ev != null)
            ev.detail.complete();
    };

    // get the default content type array
    const getDefContents = () : ContentInfo[] => {
        
        let threads = [
            CreateContentInfo(1, "addmy", "", user_avatar)
        ];

        return threads;
    }

    // just update specific content
    const getContentData = async (index: number, id : number) => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: id
        }

        var server = new NServer();
        await server.getList("nc_content", state);
        if (server.success)
        {
            if (server.data.tokens != null)
                setTokens(server.data.tokens);

            let contentData : ContentInfo = server.data.content;
            contentData = ReponsiveContentItemResize("main-con-view", contentData);

            let defStream = getDefContents();
            streams[index-defStream.length] = contentData;
            
            let streamCopy = streams.slice();
            setStreams(streamCopy);
            setContents(defStream.concat(streamCopy));
        }
    }

    // update a content
    const onUpdateContent = (index : number, content : ContentInfo, local : boolean) => {
        if (local)
        {
            // local update
            let defStream = getDefContents();
            streams[index-defStream.length] = content;
            
            let streamCopy = streams.slice();
            setStreams(streamCopy);
            setContents(defStream.concat(streamCopy));
        }
        else
        {
            // update from server
            getContentData(index, content.id);
        }
    }

    // click on love icon
    const onLike = async () => {
        router.push("/token/wallet", "forward", "push");
    }

    // click on avatar
    const onAvatar = () => {
        router.push("/settings", "forward", "push");
    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar className="content-wrapper">
                    <IonImg slot="start" className="title-img" src="assets/img/header.png"/>
                    <IonButton slot="end" fill="clear" routerLink="/noti">
                        <IonIcon slot="icon-only" icon={notificationsOutline}></IonIcon>
                        { alert != "" ? <IonBadge className="noti-bottom">{alert}</IonBadge> : <div/> }
                    </IonButton>
                    {/*
                    <IonAvatar className="avatar-top" slot="end" onClick={onAvatar}>
                        <img src={userAvatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                    </IonAvatar>
                    */}
                </IonToolbar>
            </IonHeader>
            <IonContent scrollY={false}>
                <IonRefresher className="refresher" slot="fixed" disabled={!canRefresh} onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonGrid className="ion-no-padding full-screen">
                    <IonRow className="full-screen">
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="5" size-sm="10" size="12">
                            <Virtuoso id="main-con-view" className="main-content ion-content-scroll-host"
                                atTopStateChange={onScrollTop}
                                defaultItemHeight={500}
                                data={contents}
                                totalCount={contents.length}
                                endReached={loadMoreData}
                                components={{
                                    Footer: () => {
                                        return (
                                            <NoMoreContent nomore={endOfContent} />
                                        )
                                    },
                                }}
                                itemContent={(index, content) => 
                                    <ContentWrapper key={content.id} content={content} index={index} onUpdate={onUpdateContent} view="def" autoplay={false} />
                                }
                            >
                            </Virtuoso>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default Main;